export default "__VITE_ASSET__CPlMGPc6__"